import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Input, notification, Row, Spin } from 'antd';
import AdminLogo from './assets/images/admin_logo.png';
import './assets/css/reset_password.css';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { useQuery, useResetPassword } from '../../../../utils/hooks';
import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  crossDomain: true,
  baseURL: `${process.env.REACT_APP_EVENT_URL}auth/`,
  'Access-Control-Allow-Origin': '*',
  sameSite: null,
  secure: false,
});

export default function EventAdminPasswordReset({ isEventAdmin }) {
  let query = useQuery();

  const [submitting, setSubmitting] = useState(false);
  const [successReset, setSuccessReset] = useState(false);

  const verificationId = useParams()['id'];
  const mode = query.get('mode');

  const onFinish = (values) => {
    if (_.isEqual(values.new_password, values.new_password_1)) {
      setSubmitting(true);
      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      instance
        .post(
          'password-reset',
          {
            new_password: values.new_password,
            reset_token: verificationId,
          },
          config
        )
        .then((res) => {
          notification.success({
            description: 'Password reset successful. Please login.',
          });
          setSuccessReset(true);
        })
        .catch(() => {
          notification.error({
            description: 'Password reset failed. Please try again.',
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      notification.error({
        message: <div className='gSemiBold'>There was an issue!</div>,
        style: { border: '1px #D34545 solid' },
        placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
        className: 'gRegular br10',
        description: "Your passwords don't match. Please try again.",
      });
    }
  };

  const onFinishFailed = () => {};

  return (
    <div className='admin-login-page sb-dark-blue-bg'>
      <Helmet>
        <meta charSet='utf-8' />
        <meta name='description' content='Reset your password on swimbooker' />
        <title>Reset Your Password | swimbooker</title>
      </Helmet>
      <div id='admin-login-form-content'>
        <div className='login-inside-form-content'>
          <Row>
            {/* <Button onClick={handleLogout}>Logout</Button>  */}
            <Col span={24} className='txt-center mg-bottom-20'>
              <img
                className='mg-right-10'
                width='30'
                alt='admin_logo'
                src={AdminLogo}
              />
              <span className='admin-logo-text gSemiBold'>
                <span className='sb-blue fs-30'>
                  {mode === 'signup'
                    ? 'Create '
                    : mode === 'reset'
                      ? 'Reset '
                      : 'Reset '}
                </span>
                <span className='fs-30'>Password</span>
              </span>
            </Col>
          </Row>
          {successReset ? (
            <p className='txt-center'>
              Please, click here to <a href='/event_admin/login'> Login</a>
            </p>
          ) : (
            <>
              <Row>
                <Col span={24}>
                  <div className='admin-login-form-wrapper'>
                    <div className='admin-login-form-items'>
                      <Form
                        name='basic'
                        initialValues={{
                          remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                      >
                        <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                          Password:
                        </p>
                        <Form.Item
                          // label="Username"
                          name='new_password'
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Input
                            autocomplete='off'
                            type='password'
                            className='br5 admin-secret'
                          />
                        </Form.Item>

                        <p className='dark-swim-blue gSemiBold mg-bottom-5'>
                          Re-type Password:
                        </p>
                        <Form.Item
                          // label="Password"
                          name='new_password_1'
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Input
                            autocomplete='off'
                            type='password'
                            className='br5 admin-secret'
                          />
                        </Form.Item>

                        <Form.Item>
                          <Button
                            className='admin-login-btn light-green-bg gBold'
                            type='primary'
                            htmlType='submit'
                          >
                            Reset
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
              <p className='txt-center'>
                Please, click here to <a href='/event_admin/login'> Login</a>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
